<template>
  <span>
    <base-button
      :icon="isIcon"
      size="sm"
      :disabled="isReadOnly || isPartnerAccount"
      :class="isIcon ? 'btn-link' : 'btn_extra_small btn_info white'"
      @click.native="viewItem"
    >
      <slot name="modal-link"></slot>
    </base-button>
    <modal
      v-on:close="closeForm"
      :show.sync="showModal"
      headerClasses="justify-content-center"
    >
      <h4 slot="header" class="title title-up">LINE ITEM</h4>
      <hr />
      <div class="container">
        <label style="padding-top: 10px;">Class of Supply</label>
        <v-select
          :disabled="isReadOnly || isPartnerAccount"
          v-model="replacementItem.stockClassId"
          name="stockClass"
          :class="errors.has('stockClass') ? 'has-danger' : ''"
          :error="getError('stockClass')"
          v-validate="'required'"
          data-vv-as="Class of Supply"
          label="name"
          @input="stockClassOnChange"
          :reduce="(stockclass) => stockclass.stockClassId"
          :options="sortedStockClasses"
          placeholder="Select one"
        ></v-select>
        <span v-show="errors.has('stockClass')" class="error">
          Class of Supply is required</span
        >
        <br />

        <label style="padding-top: 10px;">Sub Class</label>
        <v-select
          :disabled="isReadOnly || isPartnerAccount"
          v-model="replacementItem.stockSubClassId"
          :class="[errors.has('stockSubClass') ? 'has-danger' : '']"
          name="stockSubClass"
          v-validate="stockSubClassRule"
          data-vv-as="Sub Class"
          :error="getError('stockSubClass')"
          label="name"
          :reduce="(subclass) => subclass.stockSubClassId"
          :options="stockSubClasses"
          placeholder="Select one"
        ></v-select>
        <span v-show="errors.has('stockSubClass')" class="error"
          >Class of Supply field is required
        </span>
        <br />

        <label style="padding-top: 10px;"> Stock No. & Description</label>
        <base-input
          :disabled="isReadOnly || isPartnerAccount"
          v-model="replacementItem.stockDescription"
          name="stockDescription"
        ></base-input>

        <label style="padding-top: 10px;">Unit Of Measure</label>
        <v-select
          :disabled="isReadOnly || isPartnerAccount"
          v-model="replacementItem.unitMeasureId"
          label="name"
          :class="errors.has('unitMeasure') ? 'has-danger' : 'no'"
          name="unitMeasure"
          v-validate="'required'"
          data-vv-as="Unit of Measure"
          :error="getError('unitMeasure')"
          :reduce="(measure) => measure.id"
          :options="unitMeasures"
          placeholder="Select one"
        ></v-select>
        <span v-show="errors.has('unitMeasure')" class="error"
          >Unit of Measure is required
        </span>
        <br />
        <div>
        <label style="padding-top: 10px;">QTY Requested</label>
        <base-input
          :disabled="isReadOnly || isPartnerAccount"
          type="currency"
          min="0"
          max="800000"
          name="requestedQuantity"
          data-vv-as="Requested Quantity"
          :class="errors.has('requestedQuantity') ? 'has-danger' : 'no'"  
          v-model="replacementItem.requestedQuantity"
          @keypress="filterNumber($event)"
          v-on:blur="quantityFormatter"
          @focus="backToInput2"
          v-validate="'required'"
        ></base-input>
        <span v-show="errors.has('requestedQuantity')" class="error"
          > {{ errors.first("requestedQuantity") }}
        </span>
        </div>
        <br />
        <div>
        <label style="padding-top: 10px;">Unit Price</label>

        <base-input
          :disabled="isReadOnly || isPartnerAccount"
          type="currency"
          min="0"
          max="100000000"
          name="unitPrice"
          data-vv-as="Unit Price"
          v-model="replacementItem.unitPrice"
          :class="errors.has('unitPrice') ? 'has-danger' : 'no'"
          @keypress="filterNumber($event)"
          v-on:blur="currencyFormatter"
          @focus="backToInput"
          @paste="onPaste"
          v-validate="userValidations.unitPrice"
        ></base-input>
        <span v-show="errors.has('unitPrice')" class="error "
          > {{ errors.first("unitPrice") }}
        </span>
        </div>
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button
            type="danger"
            class="alert_footer_button btn_extra_small btn_info mr-4"
            @click.native="closeForm"
          >
            Close
          </base-button>
          <base-button
            :disabled="isReadOnly || isPartnerAccount"
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="submit"
          >
            {{ isNew ? "Save" : "Update" }}
          </base-button>
        </div>
      </template>
    </modal>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BaseButton, Modal } from "@/components";
import Util from "@/util/util";

export default {
  name: "replacement-item-modal",
  props: {
    id: {
      type: Number,
      default: 0,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    showReplacementLineItemModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modals: {
        classic: false,
      },
      priceInput: null,
      quantityInput: null,
      userValidations: {
        requestedQuantity: {
          required: true,
          min_currency: 0.01
        },
        unitPrice: {
          required: true,
          min_currency: 0.01
          
        }
      },
       
    };
  },
  components: {
    BaseButton,
    Modal,
  },
  computed: {
    ...mapGetters({
      replacementItem: "replacementItem/replacementItem",
      replacementItemErrors: "replacementItem/replacementItemErrors",
      replacementItems: "replacementItem/replacementItems",
      stockClasses: "stockClass/stockClasses",
      stockSubClasses: "stockClass/stockSubClasses",
      unitMeasures: "unitMeasure/unitMeasures",
      orderMetadata: "orderMetadata/orderMetadata",
      isPartnerAccount: "authentication/isPartnerAccount",
    }),
    stockSubClassRule() {
      return this.stockSubClasses.length > 0 ? "required" : "";
    },
    showModal() {
      return this.showReplacementLineItemModal || this.modals.classic;
    },
    sortedStockClasses() {
      return this.stockClasses.slice().sort((a, b) => { return a.rankOrder - b.rankOrder; });
  },
  },
  methods: {
    ...mapActions({
      getReplacementItems: "replacementItem/getReplacementItems",
      getReplacementItem: "replacementItem/getReplacementItem",
      getReplacementItemStatus: "replacementItem/getReplacementItemStatus",
      clearStockSubClass: "replacementItem/clearStockSubClass",
      clearReplacementItem: "replacementItem/clearReplacementItem",
      saveReplacementItem: "replacementItem/saveReplacementItem",
      getStockClasses: "stockClass/getStockClasses",
      getStockSubClasses: "stockClass/getStockSubClasses",
      getUnitMeasures: "unitMeasure/getUnitMeasures",
      getOrderByStatus: "orders/getOrderByStatus",
    }),
    quantityFormatter(event) {
      this.quantityInput = event.target.value;
      if(this.quantityInput){
      let decimalPart = this.quantityInput.split('.')[1];
      let hasMoreThanTwoDecimalPlaces = decimalPart && decimalPart.length > 2;
     let hasOnlyZerosAfterDecimal = decimalPart && /^0+$/.test(decimalPart);
      let formattedValue
      if(hasOnlyZerosAfterDecimal){
  formattedValue = parseFloat(this.quantityInput).toFixed(2);
      }
     else if(hasMoreThanTwoDecimalPlaces){
        formattedValue = this.quantityInput.toString();

      }else if(decimalPart && decimalPart.length > 2){
            formattedValue = this.quantityInput.toString();
      }else{
            formattedValue = parseFloat(this.quantityInput).toFixed(2);
      
          }
      const parts = formattedValue.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.replacementItem.requestedQuantity = parts.join("."); 
     }
    },
    onPaste(e) {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData('text');
    // Remove commas and any non-numeric characters except decimal point and minus sign
    const cleaned = pasted.replace(/[^0-9.-]/g, '');

    const input = e.target;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    // Get current value from model (or empty string)
    const currentValue = this.replacementItem.unitPrice;

    // Construct new value respecting cursor position
    const newValue = currentValue.slice(0, start) + cleaned + currentValue.slice(end);

    // Update the raw value for storage
    this.priceInput = newValue;

    // Update the model - this triggers Vue reactivity
    this.replacementItem.unitPrice = newValue;

    // Set cursor position after Vue updates (nextTick ensures DOM is updated)
    this.$nextTick(() => {
      const newCursorPos = start + cleaned.length;
      input.setSelectionRange(newCursorPos, newCursorPos);
    });
  },
    backToInput2(event) {
      if(event){
        this.replacementItem.requestedQuantity = event.target.value
      }else {
      this.replacementItem.requestedQuantity = this.quantityInput;
    }
    },
   filterNumber(evt) {
      // only allow number
      // to prevent extra chars, use event.keyCode === <charCode> || <repeat>
        evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      }

      // Prevent more than one decimal point
if (charCode === 46 && evt.target.value.includes(".")) {
  evt.preventDefault();
  return;
}

// Limit to 10 digits after the decimal point
if (evt.target.value.includes(".")) {
  var decimalPart = evt.target.value.split(".")[1];
  if (decimalPart && decimalPart.length >= 10) {
    evt.preventDefault();
    return;
  }
}
        return true;
      
    },
    loaded() {
      this.getReplacementItems(ctx.$route.params.id);
    },
    viewItem() {
      let ctx = this;
      this.errors.clear();
      ctx.getUnitMeasures();
      ctx.getStockClasses();

      if (ctx.isNew) {
        ctx.modals.classic = true;
      }
    },
    setItemNumber() {
      let ctx = this;
      //if its  new genrate new item number
      // otherwise get the current postion
      // the add 1 to convert from an index value to an acual number that makes sense to user
      if (ctx.isNew) {
        ctx.replacementItem.itemNumber =
          ctx.replacementItems && ctx.replacementItems.length > 0
            ? Math.max.apply(
                Math,
                ctx.replacementItems.map(
                  (replamentLineItem) => replamentLineItem.itemNumber
                )
              ) + 1
            : 1;
      }
    },
    showReplacementItemErrors() {
      if (this.replacementItemErrors.length > 0) {
        this.replacementItemErrors.forEach((error) => this.$toast.error(error));
      }
    },
    submit(e) {
      let ctx = this;
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          try {
            ctx.setItemNumber();
            if(this.replacementItem.unitPrice === "NaN") {
              this.$toast.error("Unit Price validation alert: Price cannot be negative.");
              return;
            } else if(this.replacementItem.requestedQuantity === "NaN") {
              this.$toast.error("Requested Quantity validation alert: Price cannot be negative.");
              return;
            }
            await ctx.saveReplacementItem(ctx.$route.params.id); //.then((response) => {
            await ctx.getReplacementItems(ctx.$route.params.id);
            await ctx.getOrderByStatus({
              orderStatus: ctx.orderMetadata.orderStatus,
              id: ctx.$route.params.id,
            });
            await ctx.getReplacementItemStatus(ctx.$route.params.id); //.then(() => {
            ctx.showReplacementItemErrors();
            ctx.closeForm();
          } catch (error) {
            ctx.isSaving = false
            ctx.$toast.error(error.response.data);
          }
         
        }else{
          const errors =  this.errors.all()
        this.$toast.error( errors.length > 1 ? 'Please complete required fields': errors[0] == 'Unit Price must be at least 0.01' ? 'Unit Price validation alert: Price cannot be negative' : errors[0] == 'Qty Requested must be at least 0.01' ? 'Quantity Requested validation alert: Quantity cannot be negative' : errors[0]);   
        }
      });
    },
    currencyFormatter(event) {
     this.priceInput = (event.target.value)
      if(this.priceInput){
       let decimalPart = this.priceInput.split('.')[1];
      let hasMoreThanTwoDecimalPlaces = decimalPart && decimalPart.length > 2;
     let hasOnlyZerosAfterDecimal = decimalPart && /^0+$/.test(decimalPart);
      let formattedValue
      if(hasOnlyZerosAfterDecimal){
  formattedValue = parseFloat(this.priceInput).toFixed(2);
      }
     else if(hasMoreThanTwoDecimalPlaces){
        formattedValue = this.priceInput.toString();

      }else if(decimalPart && decimalPart.length > 2){
            formattedValue = this.priceInput.toString();
      }else{
            formattedValue = parseFloat(this.priceInput).toFixed(2);
      
          }
      const parts = formattedValue.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.replacementItem.unitPrice = parts.join("."); 
      }
    },
    backToInput(event) {
      if(event)
{
  this.replacementItem.unitPrice = event.target.value
}     else { this.replacementItem.unitPrice = this.priceInput;}
    },
    closeForm() {
      this.modals.classic = false;
      this.$emit("modal-closed");
      this.clearReplacementItem();
      this.errors.clear();
    },
    getError(fieldName) {
      return Util.transformValidationText(this.errors.first(fieldName));
    },
    stockClassOnChange(value) {
      this.clearStockSubClass();
      this.getStockSubClasses(value);
    },
  },
};
</script>

<style>
.has-danger .vs__dropdown-toggle {
  border-color: #ec250d !important;
}

.error {
  color: #ec250d;
}
</style>